// src/components/permissions/Can.jsx
import { useAuth } from '../../hooks/useAuth'; // Fixed import path

export default function Can({ 
  permission, 
  permissions = [], 
  children, 
  fallback = null 
}) {
  const { hasPermission, hasAnyPermission } = useAuth();

  const allowed = permission 
    ? hasPermission(permission)
    : hasAnyPermission(permissions);

  return allowed ? children : fallback;
}